import styled from 'styled-components'
import { BaseButton } from 'src/styles/baseStyledComponents'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const Text = styled.span`
  padding: 55px 0px;
  margin-left: auto;
  margin-right: auto;
  font-size: 24px;
  font-weight: bold;
`

export const PrintButton = styled(BaseButton)`
  width: 100%;
  height: 64px;
`
